@let value = $value() !== undefined ? $_value() : $controlValue();
@let disabled = $disabled() !== undefined ? $disabled() : $controlDisabled();
@let readonly = $readonly();
@let controlPosition = $controlPosition();
@let verticalAlignment = $verticalAlignment() === 'center' ? 'items-center' : $verticalAlignment() === 'start' ? 'items-start' : 'items-end';
<label
  [class]="'flex' + (controlPosition === 'default' || controlPosition === 'opposite' ? ' items-center' : ' flex-col ' + verticalAlignment)"
  [class.disab]="disabled"
  [style.padding]="$innerPadding()"
  [style.gap]="$gap() | cssValue"
  [class.disab]="disabled"
  [class.readonly]="readonly"
  [matTooltip]="!disabled ? $tooltip() : $tooltipWhenDisabled()"
>
  @if ($label() !== null) {
  <p
    [class]="(readonly ? '' : 'select-none') + ($labelWrap() ? '' : ' whitespace-nowrap') + (controlPosition === 'opposite' || controlPosition === 'top' ? ' order-1' : '')"
    [style.fontSize]="$labelFontSize() | cssValue"
    [style.fontWeight]="$labelWeight()"
    [style.color]="'var(' + $labelColor() + ')'"
  >{{ $label() }}</p>
  }
  <span class="inline-block relative" [style.width]="$inputWidth()">
    <input
      #input
      class="input"
      type="text"
      [value]="value"
      [placeholder]="$placeholder()"
      [style.fontSize]="$inputFontSize() | cssValue"
      [style.width]="$inputWidth()"
      [disabled]="disabled || readonly"
      (input)="onValueChange($event)"
    >
    <span class="side-button">
      <app-button
        iconColor="--white"
        [disabled]="(disabled || readonly) ?? false"
        [icon]="value === '' || readonly ? 'magnify' : 'close-circle-outline'"
        [iconSize]="value === '' || readonly ? '27px' : '26px'"
        (click)="value === '' ? this.$inputElement().nativeElement.focus() : onClear()"
      />
    </span>
  </span>
</label>
